// extracted by mini-css-extract-plugin
module.exports = {"container":"eeb6c9d23e--container--HMUnL","title":"eeb6c9d23e--title--VjP5t","text":"eeb6c9d23e--text--sy_gV"};